import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import ArabicScatter from "@/components/landing/ArabicScatter";
import Landing from "@/components/landing/Landing";
import ContactPage from "@/pages/ContactPage";
import GuidesPage from "@/pages/GuidesPage";
import MethodePage from "@/pages/MethodePage";
import CheckoutPage from "@/pages/CheckoutPage";
import AuthPage from "@/pages/AuthPage";
import ResetPage from "@/pages/ResetPage";
import MemberPage from "@/pages/MemberPage";
import OwnerPage from "@/pages/OwnerPage";
import { AuthProvider, useAuth, API } from "@/context/AuthContext";

function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, "", "/espace");
        navigate("/espace", { replace: true });
      })
      .catch(() => navigate("/connexion", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="info-page member-loading">
      <p>Connexion avec Google en cours…</p>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Détecte le retour Google pendant le rendu (évite les conflits de session)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/guides" element={<GuidesPage />} />
      <Route path="/methode" element={<MethodePage />} />
      <Route path="/commander" element={<CheckoutPage />} />
      <Route path="/connexion" element={<AuthPage />} />
      <Route path="/reinitialisation" element={<ResetPage />} />
      <Route path="/espace" element={<MemberPage />} />
      <Route path="/proprietaire" element={<OwnerPage />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="app" data-testid="app-root">
      <div className="grain" aria-hidden="true" />
      <ArabicScatter />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}
